import { motion } from "framer-motion";
import PageHeader from "@/components/PageHeader";
import { COMPANY } from "@/data/site";

const EASE = [0.22, 1, 0.36, 1];

const TEAM = [
    { name: "Ar. Devika Panda", role: "Founding Principal", image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=800&auto=format&fit=crop" },
    { name: "Kunal Bose", role: "Managing Director", image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=800&auto=format&fit=crop" },
    { name: "Meera Mohapatra", role: "Head of Landscape", image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=800&auto=format&fit=crop" },
    { name: "Advait Menon", role: "Head of Construction", image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=800&auto=format&fit=crop" },
];

export default function About() {
    return (
        <div data-testid="page-about">
            <PageHeader
                eyebrow="The studio · Bhubaneswar"
                title={<>A premium developer, <em className="italic text-lime">built on craft.</em></>}
                lead={COMPANY.description}
            />

            <section className="relative bg-forest-900 py-24 md:py-32">
                <div className="mx-auto max-w-[1440px] px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-4">
                        <div className="font-mono-mini text-[10px] tracking-[0.32em] uppercase text-lime mb-4">
                            The number
                        </div>
                        <div className="font-serif-display text-[7rem] md:text-[10rem] leading-none italic text-ivory">37</div>
                        <div className="text-ivory/60 mt-3">landmark developments delivered</div>
                    </div>
                    <div className="md:col-span-7 md:col-start-6 space-y-6 text-ivory/80 leading-relaxed text-[1.05rem]">
                        <p>
                            KLiving specialises in luxury residential, commercial and modern
                            infrastructure projects across Odisha and East India. Our practice
                            is built around three commitments — innovative design, high-quality
                            materials and expert craftsmanship.
                        </p>
                        <p>
                            We prize excellence, transparency, timely delivery and long-term
                            customer satisfaction. Every KLiving development is designed to
                            reflect sophistication, comfort and enduring value.
                        </p>
                        <p>
                            From concept to completion, we transform visions into landmark
                            developments engineered to world-class construction standards.
                        </p>
                    </div>
                </div>
            </section>

            <section className="relative bg-forest-950 py-24 md:py-32">
                <div className="mx-auto max-w-[1440px] px-6 md:px-10">
                    <div className="flex items-center gap-4 mb-10">
                        <span className="h-px w-10 bg-lime" />
                        <span className="font-mono-mini text-[10px] tracking-[0.42em] uppercase text-lime">The team</span>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
                        {TEAM.map((m, i) => (
                            <motion.div
                                key={m.name}
                                initial={{ opacity: 0, y: 40 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.9, ease: EASE, delay: i * 0.06 }}
                                data-testid={`team-member-${i}`}
                                className="group"
                            >
                                <div className="relative overflow-hidden aspect-[3/4] bg-forest-800">
                                    <img src={m.image} alt={m.name} className="h-full w-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700" />
                                    <div className="absolute inset-0 bg-forest-900/25 group-hover:bg-transparent transition-all duration-500" />
                                </div>
                                <div className="mt-4 font-serif-display text-xl text-ivory">{m.name}</div>
                                <div className="font-mono-mini text-[10px] tracking-[0.28em] uppercase text-ivory/55 mt-1">
                                    {m.role}
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
